import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { http } from '@/bundles/Http/factory/HttpFactory';
import VoiceClassService from '@/bundles/VideoContent/services/VoiceClassService';

function voiceClassServiceFactory() {
  return new VoiceClassService({
    errorMapper: new ErrorMapper(),
    transport: http,
  });
}

export const voiceClassService = voiceClassServiceFactory();
